
const ClassAttendanceReport = () => import(/* webpackChunkName: "customer" */ "./ClassAttendanceReport");
const StudentAttendanceReport = () => import(/* webpackChunkName: "customer" */ "./StudentAttendanceReport");


export default [
  {
    path: 'attendance/class',
    name: 'class-attendance',
    component: ClassAttendanceReport,
  },
  {
    path: 'attendance/student',
    name: 'student-attendance',
    component: StudentAttendanceReport,
  },
]
